$(document).ready(function(){
  $(window).scroll(function(){
    var sticky = $('body'),
        scroll = $(window).scrollTop();

    if (scroll >= 100) sticky.addClass('Headerfixed');
    else sticky.removeClass('Headerfixed');
  });
});

// added the cookie for the pop-up
      $("#popupfoot").click(function(){
    	var check_cookie =  $.cookie('exam',1,true,{expire:60*1000});
          // alert(check_cookie);
       })
        if($.cookie('exam') ==null){
      $("#boxes").css("display","block");
          // $.cookie('exam',true,{expire:60*1000});
        }
   else{
      console.log("cookie SET");
     $("#boxes").css("display","none");
   }  
    //pop-up end  

$(document).ready(function(){
  /*************** currency geo location code *********************/
  $.getJSON("https://json.geoiplookup.io", function (data) {
    // console.log(data);
    //var countryCode = data.currency_code;
     var countryCode = 'INR';
    //console.log('CountryCode:'+countryCode);
    // var DefaultOpt= $('.site-header__icons-wrapper .currency-picker__wrapper').find('select.currency-picker option').eq(0).val();
    // console.log("DefaultOpt"+DefaultOpt);
    $('.currency-picker__wrapper').find('select.currency-picker option').each(function( index ) {
      var OptCurrency= $(this).val();
      if(OptCurrency == countryCode){
       $(this).parent('select.currency-picker').val(countryCode);
        console.log('CountryCode:'+countryCode);
        $('select.currency-picker').addClass("intro").val(countryCode).trigger("click");    
      }
    });
  });
  /*************** currency geo location code end*********************/
  
  /*************** add to cart selected related product *********************/
  $(".ProductRelatedInnerDiv").click(function(){
    var Rblanktitle = "";
    $(this).toggleClass("ActiveRelatedPrdt");
    
    
    $(".ProductRelatedInnerDiv.ActiveRelatedPrdt").each(function(){
      var relatedPTitle = $(this).children(".product-card").children("span.RltProductTitle").html();
      console.log("relatedPTitle " + relatedPTitle);
      relatedPTitle = "<b> "+relatedPTitle+"</b>";
      
      //var relatedPprice = $(".ActiveRelatedPrdt").find(".price__regular").find(".money").text();
     // console.log("relatedPprice " + relatedPprice);
      
      var allRelPrdtLE = relatedPTitle + Rblanktitle;
    	Rblanktitle = allRelPrdtLE;
      
     
    });
    console.log("Rblankdiv " + Rblanktitle);
      $(".product__RelatedaddTitle").html(Rblanktitle);  
  
  
  });
  
  

  
  /*************** add to cart selected related product *********************/
  
});
